import React from 'react';
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { Outlet, useLocation } from 'react-router-dom';
import CookieBanner from '../components/CookieBanner/CookieBanner';


const Layout = () => {
    const location = useLocation();

    const hideHeaderOn = ["/login", "/dashboard"];

    return (
        <>
            <div className="flex flex-col items-center justify-center w-full h-full">
                <Header />
                <CookieBanner />
                <Outlet />
                {!hideHeaderOn.includes(location.pathname) && <Footer />}
            </div>
        </>
    );
};

export default Layout;
